import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { SettingsProvider } from "@/lib/settings";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import Landing from "@/pages/Landing";
import OrderPage from "@/pages/OrderPage";
import TrackPage from "@/pages/TrackPage";
import AdminPage from "@/pages/AdminPage";
import ReceiptPage from "@/pages/ReceiptPage";

const AuthPage = ({ children }) => (
  <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 speed-lines">{children}</div>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ClerkAuthProvider>
          <SettingsProvider>
            <SiteHeader />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/pesan" element={<OrderPage />} />
                <Route path="/cek-pesanan" element={<TrackPage />} />
                <Route path="/kuitansi/:token" element={<ReceiptPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
                <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
              </Routes>
            </main>
            <SiteFooter />
          </SettingsProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
      <Toaster richColors theme="dark" position="top-center" />
    </div>
  );
}

export default App;
